module.exports = __webpack_public_path__ + "static/Calibre-MediumItalic-4afe8032c647b57de924543c052e0ee4.woff";